<template>
  <el-form
    :model="loginForm"
    :rules="loginRules"
    ref="loginForm"
    label-position="left"
    label-width="0px"
    class="login-ruleForm login-container"
  >
    <div class="logoContainer">
      <img
        src="../assets/images/4f6f6f316cde4398d201cd67e44ddea3.svg"
        v-show="flag === 2"
        alt="logo"
      />
      <img
        src="../assets/images/500c1180a96859e5c54a5359f024a397.svg"
        v-show="flag === 1"
        alt="logo"
      />
      <img
        src="../assets/images/ad7fa76844a2df5c03151ead0ce65ea6.svg"
        v-show="flag === 0"
        alt="logo"
      />
    </div>
    <div class="panel-heading">
      <h3 class="text-center">
        Sign In to
        <strong class="text-custom">wallpaper</strong>
      </h3>
    </div>
    <el-form-item prop="account">
      <el-input
        type="text"
        v-model="loginForm.account"
        auto-complete="off"
        placeholder="请输入邮箱号或者用户名"
        @focus="flag = 1"
        @blur="flag = 0"
      ></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input
        type="password"
        v-model="loginForm.checkPass"
        auto-complete="off"
        placeholder="密码"
        @focus="flag = 2"
        @blur="flag = 0"
        @keyup.enter.native="handleSubmit"
      ></el-input>
    </el-form-item>
    <el-form-item style="width: 100%">
      <el-button
        type="primary"
        style="width: 100%"
        @click.native.prevent="handleSubmit"
        :loading="logining"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { login } from '../api/auth'
export default {
  data() {
    return {
      logining: false,
      flag: 0,
      loginForm: {
        account: '',
        checkPass: ''
      },
      loginRules: {
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        checkPass: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit: function () {
      const _this = this
      _this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          console.log('form not validate')
          return false
        }
        _this.logining = true
        const loginParams = {
          loginName: _this.loginForm.account,
          password: _this.loginForm.checkPass
        }
        console.log(loginParams, '登录参数')
        login(loginParams)
          .then((res) => {
            if (res.success) {
              this.$store.dispatch('user/updateUserInfo', res.data)
              _this.$router.replace({
                path: _this.$route.query.redirect || '/'
              })
            } else {
              _this.logining = false
              this.$message({
                type: 'error',
                message: res.errMessage
              })
            }
          })
          .catch((err) => {
            _this.logining = false
            this.$message({
              type: 'error',
              message: err
            })
          })
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.logoContainer {
  position: absolute;
  top: -87px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
